/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LinkUserIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Link User',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M17.231 28.412a8.242 8.242 0 0 1-3.306-.587c-.52.52-1.5 1.547-1.713 1.762a4.1 4.1 0 1 1-5.8-5.8L13.6 16.6a4.585 4.585 0 0 1 3.366-1.292 3.939 3.939 0 0 1 2.678 1.112 6.292 6.292 0 0 1 .523.609 6.64 6.64 0 0 1 2.022-2.057 6.413 6.413 0 0 0-.5-.594 7.311 7.311 0 0 0-10.26.048l-7.19 7.186A7.175 7.175 0 0 0 14.37 31.774a7.869 7.869 0 0 1 2.861-3.362ZM23.722 6.479a4.1 4.1 0 1 1 5.8 5.8l-1.81 1.809a6.371 6.371 0 0 1 2.852 1.5l1.136-1.135A7.176 7.176 0 0 0 21.547 4.3c-.385.385-4.264 4.222-5.351 5.309a8.3 8.3 0 0 1 3.742.607c.521-.516 3.569-3.522 3.784-3.737Z"
    />
    <path
      d="M19.157 23.522a8.674 8.674 0 0 1-.236-1.865c0-.338.048-.652.078-.975a3.941 3.941 0 0 1-2.667-1.105 4.159 4.159 0 0 1-1.241-1.625 2.041 2.041 0 0 0-.428.318l-1.636 1.712a7.164 7.164 0 0 0 1.227 1.673 6.806 6.806 0 0 0 4.903 1.867ZM28.668 28.227v-1.385a.958.958 0 0 1 .244-.618 7.317 7.317 0 0 0 1.664-4.566c0-3.455-1.833-5.386-4.6-5.386s-4.653 2.007-4.653 5.386a7.4 7.4 0 0 0 1.743 4.566.958.958 0 0 1 .244.619v1.379a.952.952 0 0 1-.83.96c-5.563.484-6.432 4.289-6.432 5.79 0 .167.02.823.032.987h19.843s.017-.82.017-.987c0-1.438-.983-5.23-6.445-5.785a.956.956 0 0 1-.827-.96Z"
    />
  </svg>`;
};
